import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SetupPage from './pages/SetupPage';
import ReisenPage from './pages/ReisenPage';
import ReiseDetailPage from './pages/ReiseDetailPage';
import MasterListePage from './pages/MasterListePage';

function Protected({ children }) {
  return localStorage.getItem('packliste_token') ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/" element={<Protected><ReisenPage /></Protected>} />
        <Route path="/reise/:id" element={<Protected><ReiseDetailPage /></Protected>} />
        <Route path="/master" element={<Protected><MasterListePage /></Protected>} />
      </Routes>
    </BrowserRouter>
  );
}
